module.exports = __webpack_public_path__ + "img/gestalt_profile.cf3e38d8.png";